<template>
  <div>
    <div class="tabs">
      <ul>
        <li v-for="tab in tabs" v-bind:class="{'is-active': tab.isActive}">
          <a v-html="tab.header" @click="selectTab(tab)">
            {{ tab.name }}
          </a>
         </li>
      </ul>
    </div>
    <div class="tab-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tabs: []
      }
    },
    created () {
      this.tabs = this.$children
    },
    methods: {
      selectTab (selectedTab) {
        this.tabs.forEach(
          function (tab) {
            tab.isActive = (selectedTab.name === tab.name)
            console.log(tab.isActive)
          }
        )
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// tabParentComponent.vue?39446e7a